import $ from 'jquery';
import { cca_config } from '@/config'; 

export default {
    name: 'facture-soins',
    components: {},
    props: ["produits"],
    data() {
        return {

        }
    },
    computed: {
        soins() {
            return JSON.parse(this.produits.soins)
        }
    },
    mounted() {
        setTimeout(() => {
            $(".shw").fadeIn();
        }, 500);
        // console.log('prods', this.produits)
    },
    methods: {
        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },
        printFacture() {
            this.$refs.facture_html2Pdf.generatePdf()
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'La caisse';
                let date = new Date();
                let month = date.getMonth() + 1;
                let lome_le = cca_config.VILLE+', le ' + date.getDate() + "/" + month + "/" + date.getFullYear();

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },
    }
}